import { cn } from '../../lib/cn';

export const databinexLogoSrc = '/mainLogo.webp';

export function DatabinexMark({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'grid size-12 shrink-0 place-items-center overflow-hidden rounded-2xl border border-white/15 bg-white/95 p-1.5 shadow-[0_0_34px_rgba(242,106,33,.18)]',
        className,
      )}
    >
      <img src={databinexLogoSrc} alt="" className="size-full object-contain" />
    </span>
  );
}

export function BrandLockup({ inverse = false, compact = false }: { inverse?: boolean; compact?: boolean }) {
  return (
    <div className={cn('flex items-center gap-3', inverse ? 'text-white' : 'text-ink')}>
      <DatabinexMark className={inverse ? 'text-white' : 'text-plum'} />
      {!compact && (
        <div className="leading-none">
          <div className="font-black tracking-tight">DataBInex</div>
          <div className={cn('mt-1 text-[10px] font-bold tracking-[.16em]', inverse ? 'text-white/55' : 'text-slate-400')}>ARENA</div>
        </div>
      )}
    </div>
  );
}
